import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { ContactPage } from './routes/ContactPage.tsx';
import { Landing } from './routes/Landing.tsx';
import { Layout, NotFound } from './routes/Layout.tsx';

const rootRoute = createRootRoute({
  component: Layout,
  notFoundComponent: NotFound,
});

/** No search schema on either route: nothing on this site is addressable by
 *  query string. */
const landingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Landing,
});

const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact',
  component: ContactPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([landingRoute, contactRoute]),
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultHashScrollIntoView: { behavior: 'smooth', block: 'start' },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
